export enum EProductTemplateEventName {
  CREATED = 'Product Template Created',
  USAGE_INITIATED = 'Product Template Usage Initiated',
  USAGE_COMPLETED = 'Product Template Usage Completed',
}
